<template>
	<div id="share-survey-template">
		<div class="container">
            <div class="box" v-if="surveyData">
                <h1>Download Survey Report</h1>
                <p>This survey is licensed to:</p>
                <div>
                    <p>Company</p>
                    <h3>{{surveyData.user.companyName}}</h3>

                    <p>Client Name</p>
                    <p>{{surveyData.user.firstName + " " + surveyData.user.lastName}}</p>
                </div>

                <div class="download">
					<a download :href="surveyData.survey.surveyPDFUrl" class="btn btn-small">Download Survey</a>
				</div>
                
            </div>
        </div>
	</div>
</template>

<script>

export default {
	data(){
		return {
            surveyData : null
		}
    },
    mounted(){
        let quoteRef = this.$route.params.id
        if(!quoteRef){
            return;
        }

        // load completed survey 
        this.$toasted.show("Please wait...", {
	            theme: 'bubble',
	            position: 'bottom-center',
	            duration: null
		})
        this.$store.dispatch('getCompletedSurveyForSharing', quoteRef)
        .then((response) => {

    		this.$toasted.clear();
    		if(response.confirmation === 'success'){
                this.surveyData = response.data;
                return;
    		}
    		
    		
    		this.$toasted.error(response.message, {
		        theme: 'bubble',
		        position: 'bottom-center',
		        duration: 5000
		    })
    		
    	})
    	.catch((err) => {
    		this.$toasted.clear();
    		this.$toasted.error("something went wrong. " + err.message, {
		        theme: 'bubble',
		        position: 'bottom-center',
		        duration: 5000
		    })
    	})
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ShareDownloadSurveyReport.vue